<template>
  <div class="mx-6">
    <div
      class="mb-0" 
      :class="$vuetify.breakpoint.xs ? 'text-h6 mt-4' : 'text-h5 mt-5'">
      <v-icon :large="!$vuetify.breakpoint.xs">
       mdi-clipboard-pulse-outline
      </v-icon>
     Reports
    </div>
    <v-card
        color="transparent"
        v-resize="onResize"
        class="overflow-y-auto pb-2"
        flat
        :height="cardHeight">
      <v-card-text>
        <v-row>
          <v-col v-for="report in reportLinks" :key="report.name" cols="12" lg="3" md="4" sm="6">
            <v-card color="cardbackground">
              <v-card-title class="pt-2">
                {{ report.name }}
              </v-card-title>
              <v-card-text>
                <v-btn
                  :disabled="!isOnline"
                  block
                  color="primary"
                  @click="showReport(report.link);">
                  <v-icon class="mr-2"> mdi-chart-line</v-icon>
                  View Report
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" lg="3" md="4" sm="6">
            <v-card color="cardbackground">
              <v-card-title class="pt-2">
                Power BI
              </v-card-title>
              <v-card-text>
                <v-btn
                  :disabled="!isOnline"
                  block
                  color="primary"
                  @click="openNewTab('https://app.powerbi.com/links/wO2P0C5dUa?ctid=da45342c-ce89-44fe-82c9-2c8502e05791&pbi_source=linkShare');">
                  <v-icon class="mr-2"> mdi-web</v-icon>
                  View Site
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import router from '../../router'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      cardHeight: 0,
      reportLinks: [
        { name: 'Egg Daily', link:'/reports/EggDailyReport' },
        { name: 'Egg Summary', link: '/reports/EggSummaryReport' },
        { name: 'Egg Group', link: '/reports/EggGroupReport' }
      ]
    };
  },
  computed: {
    ...mapState(['settings','isOnline'])
  },
  methods: {
    onResize() {
      this.cardHeight = window.innerHeight - 155;
    },
    showReport(link) {
      router.push({ path: link });
    },
    openNewTab(link) {
      var width = 1000;
      var height = 600;
      var left = (screen.width/2)-(width/2);
      var top = (screen.height/2)-(height/2);

      window.open(link, "EggPickerPowerBI",`width=1000,height=600,top=${top},left=${left}`);
    }
  }
}
</script>